var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"13.8747","cy":"14.5768","rx":"7.44244","ry":"7.53125","stroke":"#242424","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M13.8747 10.8112C13.386 10.8112 12.9022 10.9086 12.4507 11.0978C11.9992 11.287 11.589 11.5644 11.2434 11.9141C10.8979 12.2638 10.6238 12.6789 10.4368 13.1357C10.2498 13.5926 10.1535 14.0823 10.1535 14.5768","stroke":"#242424","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M25.0384 25.8737L21.3172 22.108","stroke":"#242424","strokeWidth":"1.5","strokeLinecap":"round","key":2})]);
}

Search.defaultProps = {"width":"30","height":"31","viewBox":"0 0 30 31","fill":"none"};

module.exports = Search;

Search.default = Search;
